import React, { Component } from 'react';
import NavMenu from './NavMenu';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <main>{this.props.children}</main>
        <ToastContainer />
      </div>
    );
  }
}
